// extracted by mini-css-extract-plugin
export default {"listItem":"TextElement_listItem__08pWj","typer":"TextElement_typer__HwxaM","typing":"TextElement_typing__9u7Yg"};